

// //toast
// import toast from '@/components/Toast';

//bind_Modal
//大区绑定
//import bind_modal from '@/components/AreaBind';

let utils = {
    // $toast: toast,
    // $bind_modal : bind_modal,
    // $invite_modal : invite_modal,
    // $copy_modal : copy_modal,
    // $invite_apply : invite_apply,
    // $msg_modal : msg_modal,
}

export default utils;